import axios from 'axios';
import { createAsyncThunk, createSlice, isFulfilled, isPending, isRejected } from '@reduxjs/toolkit';
import { API_ROUTES } from '@/config/api-routes';
import { serializeAxiosError, resolveAsyncThunkErrorMessage } from './reducer.utils';
const initialState = {
    loading: false,
    errorMessage: null,
    report: [],
    totalItems: 0,
};
const apiUrl = API_ROUTES.qstat.agentProductivity;
export const getAgentProductivityReport = createAsyncThunk('agentProductivityReport/fetch', async ({ username, dateFrom, dateTo }) => {
    const params = new URLSearchParams();
    if (username?.trim()) {
        params.append('username', username.trim());
    }
    if (dateFrom) {
        params.append('dateFrom', dateFrom);
    }
    if (dateTo) {
        params.append('dateTo', dateTo);
    }
    const query = params.toString();
    const requestUrl = query ? `${apiUrl}?${query}` : apiUrl;
    return axios.get(requestUrl);
}, { serializeError: serializeAxiosError });
export const AgentProductivityReportSlice = createSlice({
    name: 'agentProductivityReport',
    initialState: initialState,
    reducers: {
        reset() {
            return initialState;
        },
    },
    extraReducers(builder) {
        builder
            .addMatcher(isFulfilled(getAgentProductivityReport), (state, action) => {
            state.loading = false;
            state.report = action.payload.data;
            const totalHeader = action.payload.headers['x-total-count'];
            state.totalItems = totalHeader ? parseInt(totalHeader, 10) : action.payload.data.length;
        })
            .addMatcher(isPending(getAgentProductivityReport), state => {
            state.errorMessage = null;
            state.loading = true;
        })
            .addMatcher(isRejected(getAgentProductivityReport), (state, action) => {
            state.loading = false;
            state.errorMessage = resolveAsyncThunkErrorMessage(action.error);
        });
    },
});
export const { reset } = AgentProductivityReportSlice.actions;
export default AgentProductivityReportSlice.reducer;
